import React from "react";
import Wrapper from "./bankStatementPrompt.styles";
import { AnimatedToggle } from "@components/animatedHeight";
import { Paragraph } from "@components/paragraph";
import { TextButton } from "@components/textButton";
import { FIELD_NAMES } from "../../../../constants/commonConstants";

export const BankStatementPrompt = ({setFieldValue, showBankStatements}) => {
  const onClick = () => setFieldValue(FIELD_NAMES.BANK_STATEMENT_REFERRAL_CODE_SKIP, false);
  
  return (
    <AnimatedToggle show={!showBankStatements}>
      <Wrapper>
        <div className="paragraph-wrapper">
          <Paragraph>
            Please note to complete your application process you will need to provide your bank
            statements. <br />
            <TextButton onClick={onClick}>Click here</TextButton> to
            submit your bank statements
          </Paragraph>
        </div>
      </Wrapper>
    </AnimatedToggle>
  )
}